import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";
import { MdOutlineCancel } from "react-icons/md";
// import logo from "../../assets/ai.jpg.png";
import latestlogo from "../../assets/accessnewlogo.png";
import latestlogoText from "../../assets/accessnewtext.png";
// import latestlogo from '../../assets/latestLogo.png';
import { useContext, useEffect, useRef, useState } from "react";
import IntersectionObserverHook from "../../CustomHooks/IntersectionObserverHook";
import { ObserverContext } from "../../Contexts/ObserverContext";
import * as _ from "lodash";

function Navbar({ navigation }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isBlogDropdownOpen, setIsBlogDropdownOpen] = useState(false);

  const {
    //  serviceRef,
    //  verticalsRef,
    //  methodologyRef,
    //  contactRef,
    //  sliderRef,
    //  teamRef,
    //  startPortfolioRef,
    activeSection,
    setActiveSection,
    // homeRef,
    // learnMoreRef,
    // startCounterRef,
    // successStoriesRef,
    // startQuoteRef,
  } = useContext(ObserverContext);

  let isSliderVisible;
  let isServicesVisible;
  let isTeamVisible;
  let isWorkVisible;
  let isVerticalsVesible;
  let isMethodologyVisible;
  let isContactVisible;

  // window.location.pathname
  // /database-services
  // /erp-services
  useEffect(() => {
    // ------------------------------
    //   Load Google Tag Script
    // ------------------------------
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-16553503976";
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "AW-16553503976");

    // ------------------------------
    //   Your Existing Logic
    // ------------------------------
    // console.log(window.location.pathname, 'hhhhhhhhhhhhhhhhhhhhhhhh');

    if (
      window.location.pathname === "/database-services" ||
      window.location.pathname === "/erp-services" ||
      window.location.pathname === "/custom-development"
    ) {
      setActiveSection("services");
    }

    if (_.startsWith(window.location.pathname, "/read-more")) {
      setActiveSection("work");
    }
  }, []);

  //   useEffect(() => {

  //   //  setTimeout(() => {

  //   //     // isSliderVisible = IntersectionObserverHook(sliderRef);
  //   //     // isServicesVisible = IntersectionObserverHook(serviceRef);
  //   //     // isTeamVisible = IntersectionObserverHook(teamRef);
  //   //     // isWorkVisible = IntersectionObserverHook(startPortfolioRef);
  //   //     // isVerticalsVesible = IntersectionObserverHook(verticalsRef);
  //   //     // isMethodologyVisible = IntersectionObserverHook(methodologyRef);
  //   //     // isContactVisible = IntersectionObserverHook(contactRef);

  //   //     // console.log("Values for check = ", isSliderVisible, isServicesVisible, isTeamVisible, isWorkVisible, isVerticalsVesible, isMethodologyVisible, isContactVisible);
  //   //  }, 1000);

  //   //  console.log('this is navigation', navigation);
  //   //  const onHashChange = () => {
  //   //     //  setRouteHash(window.location.hash);
  //   //     console.log('this is navbar useEffect', window.location.hash);
  //   //  };

  //   //  window.addEventListener('hashchange', onHashChange);

  //   //  return () => {
  //   //      window.removeEventListener('hashchange', onHashChange);
  //   //  };

  //   //  if () any of threee activeSetion set service.
  //   console.log(window.location.pathname,'hhhhhhhhhhhhhhhhhhhhhhhh')
  //   if(window.location.pathname === '/database-services' || '/erp-services' || '/custom-development')
  // {
  //   setActiveSection('services');
  // }

  // if(_.startsWith(window.location.pathname, '/read-more')){
  //   setActiveSection('work')
  // }

  // },[]);

  const hamMneuRef = useRef();

  const toggleNav = () => {
    hamMneuRef.current.classList.toggle("side-menu-active");
  };

  return (
    // <p>This is Navbar Page</p>
    <header className="navigation-bar">
      <nav className="navbar navbar-expand-md navbar-light bg-light fixed-top navbar-fixed-top">
        <div className="container">
          <a
            href="/"
            className="navbar-brand d-flex align-items-center"
            style={{ gap: "25px", marginRight: "6rem" }} // space between logo and text logo
          >
            <img src={latestlogo} alt="Logo" style={{ height: "60px" }} />

            <img
              src={latestlogoText}
              alt="Logo Text"
              style={{ height: "50px" }} // adjust height as needed
            />
          </a>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ml-auto">
              <li
                className={
                  "nav-item " + (activeSection === "home" ? "active" : "")
                }
              >
                <a
                  className={
                    "nav-link  " + (activeSection === "home" ? "active" : "")
                  }
                  href="/"
                >
                  Home
                </a>
              </li>
              <li
                className={
                  "nav-item dropdown " + (isDropdownOpen ? "show" : "")
                }
                style={{ position: "relative" }}
              >
                <a
                  className={`nav-link dropdown-toggle ${isDropdownOpen ? "active-dropdown" : ""}`}
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsDropdownOpen(!isDropdownOpen);
                  }}
                >
                  Access ONE ERP
                </a>
                <ul
                  className={"dropdown-menu " + (isDropdownOpen ? "show" : "")}
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: "0",
                  }}
                >
                  <li>
                    <a className="dropdown-item" href="/manufacture">
                      Manufacturing ERP
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/retail">
                      Retail ERP
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/school">
                      School Management ERP
                    </a>
                  </li>
                </ul>
              </li>
              <li
                className={
                  "nav-item " + (activeSection === "team" ? "active" : "")
                }
              >
                <a
                  className={
                    "nav-link  " + (activeSection === "team" ? "active" : "")
                  }
                  href="/team"
                >
                  Team
                </a>
              </li>
              <li
                className={
                  "nav-item " + (activeSection === "projects" ? "active" : "")
                }
              >
                <a
                  className={
                    "nav-link  " +
                    (activeSection === "projects" ? "active" : "")
                  }
                  href="/projects"
                >
                  Projects
                </a>
              </li>
              <li
                className={
                  "nav-item " + (activeSection === "contact" ? "active" : "")
                }
              >
                <a
                  className={
                    "nav-link  " + (activeSection === "contact" ? "active" : "")
                  }
                  href="/contact"
                >
                  Contact Us
                </a>
              </li>

           
               <li
                className={
                  "nav-item dropdown " + (isBlogDropdownOpen ? "show" : "")
                }
                style={{ position: "relative" }}
              >
                <a
                  className={`nav-link dropdown-toggle ${isBlogDropdownOpen ? "active-dropdown" : ""}`}
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsBlogDropdownOpen(!isBlogDropdownOpen);
                  }}
                >
                  Blogs
                </a>
                <ul
                  className={"dropdown-menu " + (isBlogDropdownOpen ? "show" : "")}
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: "0",
                  }}
                >
                  <li>
                    <a className="dropdown-item" href="/our-vision">
                      Use ERP to Increase Efficiency
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/blog">
                      Reduce Manufacturing delays with ERP  
                    </a>
                  </li>
                </ul>
              </li>
                 <li
                className={
                  "nav-item " +
                  (activeSection === "privacy-policy" ? "active" : "")
                }
              >
                <a
                  className={
                    "nav-link  " +
                    (activeSection === "privacy-policy" ? "active" : "")
                  }
                  href="/privacy-policy"
                >
                  Privacy
                </a>
              </li>
              {/* <li
                className={
                  "nav-item " + (activeSection === "our-vision" ? "active" : "")
                }
              >
                <a
                  className={
                    "nav-link  " +
                    (activeSection === "our-vision" ? "active" : "")
                  }
                  href="/our-vision"
                >
                  Blogs
                </a>
              </li> */}
              <li
                className={
                  "nav-item " + (activeSection === "plans" ? "active" : "")
                }
              >
                <a
                  className={
                    "nav-link offer " +
                    (activeSection === "plans" ? "active" : "")
                  }
                  href="/plans"
                >
                  Latest Offer
                </a>
              </li>
            </ul>
          </div>
        </div>
        <button
          type="button"
          className="sidemenu_btn"
          onClick={toggleNav}
          style={{
            background: "transparent",
            border: "none",
            padding: "8px",
            boxShadow: "none",
          }}
        >
          <span></span>
          <span></span>
          <span></span>
          {/* </a> */}
        </button>
      </nav>

      {/* <!-- Side Menu --> */}
      <div className="side-menu hidden " ref={hamMneuRef}>
        <div className="inner-wrapper">
          <div className="image">
            <img
              src={latestlogo}
              style={{ height: "60px", width: "80px", marginBottom: "8px" }}
              alt="image"
            />
          </div>
          {/* Icon for close. */}
          <MdOutlineCancel
            className="btn-close"
            onClick={toggleNav}
            id="btn_sideNavClose"
          ></MdOutlineCancel>
          {/* <span className="btn-close" onClick={toggleNav} id="btn_sideNavClose">
            <i></i>
            <i></i>
          </span> */}
          <nav className="side-nav w-100">
            <ul className="navbar-nav">
              <li className="nav-item ">
                <a className="nav-link scroll" onClick={toggleNav} href="#home">
                  Home
                </a>
              </li>
              <li className="nav-item ">
                <a
                  className="nav-link scroll"
                  onClick={toggleNav}
                  href="/services"
                >
                  Access ONE ERP
                </a>
              </li>
              {/* <li className="nav-item ">
                <a className="nav-link scroll" onClick={toggleNav} href="/accomplishments">
                  Accomplishments
                </a>
              </li> */}
              <li className="nav-item ">
                <a className="nav-link scroll" onClick={toggleNav} href="/team">
                  Team
                </a>
              </li>
              <li className="nav-item ">
                <a
                  className="nav-link scroll"
                  onClick={toggleNav}
                  href="/projects"
                >
                  Projects
                </a>
              </li>
              {/* <li className="nav-item ">
                <a className="nav-link scroll" onClick={toggleNav} href="/alliances">
                  Alliances
                </a>
              </li> */}
              <li className="nav-item ">
                <a
                  className="nav-link scroll"
                  onClick={toggleNav}
                  href="/contact"
                >
                  Contact Us
                </a>
              </li>
              <li className="nav-item ">
                <a
                  className="nav-link scroll"
                  onClick={toggleNav}
                  href="/privacy-policy"
                >
                  Privacy
                </a>
              </li>
            </ul>
          </nav>
          {/* <div className="side-menu-footer">
            <div className="banner-icons">
              <ul>
                <li>
                  <a href="javascript:void(0);" className="hover">
                    <FaFacebook></FaFacebook>
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" className="hover">
                    <FaTwitter></FaTwitter>
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" className="hover">
                    <FaLinkedin></FaLinkedin>
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" className="hover">
                    <FaInstagram></FaInstagram>
                  </a>
                </li>
              </ul>
            </div>
            <p className="copywrite text-left">
              © 2023 Access Infotech Solution. Made With Love by Dev Inventiv
              Solutions.
            </p>
          </div> */}
        </div>
      </div>
      {/* <a id="close_side_menu" href="javascript:void(0);"></a> */}
      <button
        id="close_side_menu"
        type="button"
        onClick={toggleNav}
        style={{ display: "none" }}
      ></button>
    </header>
  );
}

export default Navbar;
